// extracted by css-extract-rspack-plugin
export default {"cls1":"UpsellModalRedesign-cls1_8g8","cls2":"UpsellModalRedesign-cls2_vvQ UpsellModalRedesign-cls1_8g8","primary":"UpsellModalRedesign-primary_EF-"};